module.exports = __webpack_public_path__ + "assets/fonts/6d1cdce2-f2a8-4ed7-add1-ba867060e191.7e9f4b96.woff2";